export default {
  state: {
    currentCustomer: {
      id: null,
      name: 'Loading...',
      phone: '',
      bank_id: null
    }
  },
  getters: {
    currentCustomer: state => state.currentCustomer,
    currentCustomerId: state => {
      return (state.currentCustomer.id) ? state.currentCustomer.id : ''
    },
    currentCustomerName: state => {
      return (state.currentCustomer.id) ? state.currentCustomer.name : 'Loading...'
    },
    currentCustomerPhone: state => {
      return (state.currentCustomer.id) ? state.currentCustomer.phone_number : 'Loading...'
    },
    currentCustomerBankId: state => {
      return (state.currentCustomer.id) ? state.currentCustomer.bank_id : ''
    },
    currentCustomerUsers: state => {
      return (state.currentCustomer.id && state.currentCustomer.users) ? state.currentCustomer.users : []
    },
    currentCustomerAssessmentHistory: state => {
      return (state.currentCustomer.id && state.currentCustomer.submissions) ? state.currentCustomer.submissions : []
    },
  },
  mutations: {
    currentCustomer (state, customer: Customer) {
      console.log('commit currentCustomer', customer)
      if (customer) {
        state.currentCustomer = customer
      }
    },
    clearCurrentCustomer (state) {
      state.currentCustomer = {
        id: null,
        name: 'Loading...',
        phone: '',
        bank_id: null
      }
    }
  },
  actions: {

    async postNewCustomer ({getters}, customer: Customer) {
      console.log('store.postNewCustomer', customer)
      const api = getters.api
      let response: any
      if (getters.sessionUserIsBank) {
        response = await api.post(`customers`, customer)
      } else {
        response = await api.post(`banks/${customer.bank_id}/customers`, customer)
      }
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not add new customer."
        }
      }
      return response.data
    },

    async getCustomer ({commit, getters}, customerId: number) {
      console.log('store.getCustomer', customerId)
      const api = getters.api
      const response = await api.get('customers/'+customerId)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get customer details."
        }
      }
      return response.data
    },

    async loadCustomer ({commit, getters, dispatch}, customerId: number) {
      console.log('store.loadCustomer', customerId)
      const result = await dispatch('getCustomer', customerId)
      commit('currentCustomer', (result.success ? result.data : []))
      return result
    },

    async getBankCustomers ({commit, getters}, bankId: number) {
      console.log('store.getBankCustomers', bankId)
      const currentBank = getters.currentBank
      if (!bankId && currentBank && currentBank.id) bankId = currentBank.id
      const api = getters.api
      let response: any
      if (getters.sessionUserIsBank) {
        response = await api.get('customers')
      } else if (bankId) {
        response = await api.get(`banks/${bankId}/customers`)
      } else {
        return {
          success: false,
          message: "Missing bank ID."
        }
      }
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get customers list."
        }
      }
      return response.data
    },

    async patchCustomer ({getters}, customer: Customer) {
      console.log('store.patchCustomer', customer)
      const api = getters.api
      const response = await api.patch('customers/'+customer.id, customer)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not update customer details."
        }
      }
      return response.data
    },

    async addOrUpdateCustomer ({dispatch}, customer: Customer) {
      if (!customer) {
        return {
          success: false,
          message: 'No data'
        }
      }
      if (customer.id) {
        return await dispatch('patchCustomer', customer)
      } else {
        return await dispatch('postNewCustomer', customer)
      }
    },

    async deleteCustomer ({getters}, customer: Customer) {
      console.log('store.deleteCustomer', customer)
      const api = getters.api
      const response = await api.delete('customers/'+customer.id)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not deauthorize customer."
        }
      }
      return response.data
    },

    // Debug

    logState ({state}) {
      console.log('store.customers', state)
    }

  }
}
